export const DOCUMENT_TYPES = {
    EDITOR: 'Editor',
    TEMPLATE: 'Template',
    CHAT: 'Chat',
};
